// Supports font weights 200 - 800
import "@fontsource-variable/manrope";

import { BProgress } from "@bprogress/core";
import { browserTracingIntegration, init as initSentry } from "@sentry/vue";
import dayjs from "dayjs";
import dayjsDuration from "dayjs/plugin/duration";
import dayjsIsBetween from "dayjs/plugin/isBetween";
import { createPinia } from "pinia";
import { createApp } from "vue";

import { appConfig } from "#config";
import { componentsPlugin } from "#plugins/components";
import { vueQueryPlugin } from "#plugins/vue-query";
import { vuetifyPlugin } from "#plugins/vuetify";
import App from "./App.vue";
import { router } from "./router/router";

import "@bprogress/core/css";
import "#styles/app.scss";

dayjs.extend(dayjsDuration);
dayjs.extend(dayjsIsBetween);

const app = createApp(App);
const pinia = createPinia();

initSentry({
  app,
  environment: appConfig.environment,
  dsn: "https://be860be4f97728ea1c0162ddc085c94a@o4507690896850944.ingest.us.sentry.io/4509826781347840",
  integrations: [browserTracingIntegration({ router, routeLabel: "path" })],
  // Performance monitoring (capture 100% of transactions)
  tracesSampleRate: 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", appConfig.links.api],
});

app.use(pinia).use(router).use(componentsPlugin).use(vueQueryPlugin).use(vuetifyPlugin);

app.mount("#app");

// NOTE: BProgress styles must be loaded before main app styles!
BProgress.configure({
  indeterminate: true,
  showSpinner: false,
});
